import { useState, type ReactNode } from 'react';
import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
import { HashRouter } from 'react-router';
import { createQueryClient } from './api/queryClient';
import { AuthProvider } from './auth/AuthContext';
import { ThemeProvider } from './theme/ThemeContext';
import { Toaster } from './ui/Toaster';

/** Everything except the router-specific bits lives here so tests can swap the router. */
export function AppProviders({
  children,
  client,
  router: Router = HashRouter,
}: {
  children: ReactNode;
  client?: QueryClient;
  router?: (p: { children: ReactNode }) => ReactNode;
}) {
  const [qc] = useState(() => client ?? createQueryClient());
  return (
    <ThemeProvider>
      <QueryClientProvider client={qc}>
        <Router>
          <AuthProvider>{children}</AuthProvider>
        </Router>
        <Toaster />
      </QueryClientProvider>
    </ThemeProvider>
  );
}
